<template>
    <div v-if="errorBag.length > 0">
        <div v-for="error in errorBag">
            <div style="background: #ff0000; color: white;" v-if="error.fieldName === fieldName">{{ error.errorMessage }}</div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "ErrorMessage",
        props: {
          errorBag: {
              type: Array,
          },
            fieldName: {
              type: String
            }
        },
    }
</script>
